module.exports = __webpack_public_path__ + "static/img/260_TO8_2339.c5344ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/260_TO8_2339.jpg
// module id = Kx5R
// module chunks = 0